const genericStrings = {
    stepCount: "Step {current} of {total}",
    dragHint: "Drag to reorder",
    shiftHours: "Shift hours",
    quantity: "Quantity",
    rate: "Rate",
    printState: "Print state",
    showAccount: "View account",
    closed: "Closed",
    applyToWeek: "Apply to the whole week",
    addSlot: "Add a time range",
    copy: "Copy",
    url: "URL",
    mode: "Mode",
    bulk: "Bulk",
    style: "Style",
    customName: "Custom name",
    customTableName: "Custom table name",
    prefix: "Prefix",
    startTable: "Start table",
    endTable: "End table",
    single: "Single",
    unlimited: "Unlimited",
    custom: "Custom",
    dayRequired: "The day is required.",
    startHourRequired: "The start time is required.",
    endHourRequired: "The end time is required.",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    displayOrder: "Order",
    add: "Add",
    group: "Group",
    image: "Image",
    visibility: "Visibility",
    searchByName: "Search by name",
    searchByGroup: "Search by group",
    email: "Email",
    notAvailable: "N/A",
    noResult: "No result.",
    searchResultsFor: "{count} result for “{query}” | {count} results for “{query}”",
    noResultHint: "Try another search term.",

    voucher: "Vouchers",
    showPassword: "Show password",
    hidePassword: "Hide password",
    notDefined: "Not set",
    allSaved: "All changes saved",
    unsavedChanges: "1 change | {count} changes",
    copied: "Copied",
    remove: "Remove",
    apply: "Apply",
    invalidUrl: "Enter a valid URL starting with https://",
    addImage: "Upload an image",
    addFile: "Upload a file",
    fileTypeError: "This file type is not accepted",
    openingHours: "Opening Hours",
    appRefund: "Refund",
    appHideCashboxButton: "Hide cashbox button",
    appNoPinUserLogin: "User login without PIN code",
    serviceMode: "Order",
    duplicateProductWithGroup: "Include the group's products in the duplication?",
    normal: "Normal",
    existingClient: "Existing client",
    newClient: "New client",
    next: "Next",
    previous: "Previous",
    assignClient: "Assign Client",
    searchClient: "Select a client",
    onSite: "On site",
    cancelOrderedProduct: "Cancel ordered products",
    showOnlyOwnAccounts: "Show only own accounts",
    cleanOption: "Remove sub-options",
    showProduct: "Go to product",
    showGroupsProduct: "View group products",
    username: "Username",
    password: "Password",
    org_id: "Organization ID",
    sendInvoice: "Send invoice",
    customInvoiceNumber: "Invoice number",
    vatTicket: "VAT ticket",
    vatTicketSend: "Send by email",
    vatTicketDownloadHint: "The VAT ticket will be downloaded as a PDF.",
    submit: "Send",
    edit: "Edit",
    hide: "Hide",
    preview: "Preview",
    moveUp: "Move up",
    moveDown: "Move down",
    duplicate: "Duplicate",
    show: "Show",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    back: "Back",
    search: "Search",
    clearFilter: "Clear filter",
    download: "Download",
    send: "Sent",
    created: "Created",
    canceled: "Canceled",
    downloadX: "Download X",
    downloadZ: "Download Z",
    confirmLeave: "You have unsaved changes.<br/>Do you really want to leave this page?",
    from: "From",
    to: "To",
    digitalMenu: "Digital menu",
    viewApiDocs: "API documentation",
    deliveryArea: "Delivery areas",
    startDate: "Start date",
    endDate: "End date",
    dateRange: "Date range",
    clear: "Clear",
    total: "Total",
    paid: "Paid",
    globalSearch: "Global search",
    vat: "VAT",
    user: "User",
    comment: "Comment",
    price: "Price",
    accountId: "Account ID",
    name: "Name",
    id: "Id",
    actions: "Actions",
    refresh: "Refresh",
    account: "Account",
    accountInfo: "Account info",
    status: "Status",
    openedAt: "Open At",
    closedAt: "Closed At",
    open: "Open",
    close: "Close",
    tableNumber: "Table",
    noName: "No name",
    delete: "Delete",
    takeaway: "Takeaway",
    deleteConfirm: "Are you sure you want to delete this ?<br> This action cannot be undone !",
    removeFromSelection: "Remove from the selection",
    date: "Date",
    filter: "Filter",
    matchContains: "Contains",
    matchNotContains: "Does not contain",
    matchStartsWith: "Starts with",
    matchEndsWith: "Ends with",
    matchEquals: "Equals",
    ipAddress: "Address",
    yes: "Yes",
    color: "Color",
    no: "No",
    all: "All",
    changePayType: (ctx) => `Change payment type of ${ctx.named('of')} from ${ctx.named('from')} to ${ctx.named('to')} ? `,
    tables: "Tables",
    delivery: "Delivery",
    shift: "Shifts",
    openAccounts: "Open Accounts",
    openTicketsCurrentShift: "Current shift accounts",
    lastShift: "Last Shift",
    dailySales: "Daily Sales",
    rushHours: "Rush Hours",
    dashboardIntervalChoice: 'Selected Interval',
    dashboardIntervalCurrentShift: 'Current Shift',
    dashboardIntervalLastShift: 'Last Shift',
    dashboardIntervalYesterday: 'Yesterday',
    dashboardIntervalThisWeek: 'This Week',
    dashboardIntervalLastWeek: 'Last Week',
    dashboardIntervalThisMonth: 'This Month',
    dashboardIntervalLastMonth: 'Last Month',
    dashboardIntervalLast7Days: 'Last 7 Days',
    dashboardIntervalLast30Days: 'Last 30 Days',
    dashboardIntervalLast90Days: 'Last 90 Days',
    dashboardIntervalCustom: 'Custom',
    dateTimePlaceholder: 'dd/mm/yyyy hh:mm',
    datePlaceholder: 'dd/mm/yyyy',
    clients: 'Clients',
    superUserShort: 'SU',
    mail: 'Email',
    phone: 'Phone',
    address: 'Address',
    street: 'Street',
    city: 'City',
    shiftUser: "Wroker Shift",
    noDataFound: "No data found",
    itemsSelected: "{count} selected",
    loadingData: "Loading data, please wait.",
    fileSizeError: "File size is too big, choose a file smaller than {size} MB",
    fileAttached: "{name} — will be uploaded on save",
    pickup: "Pickup location",
    promo: "Promotion",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    login: "Login",
    product: "Products",
    productGroup: "Product Groups",
    table: "Tables",
    select: "Select",
    bulkEdit: "Bulk Edit",
    bulkEditProducts: "Edit {count} product | Edit {count} products",
    bulkEditGroups: "Edit {count} group | Edit {count} groups",
    printer: "Printers",
    client: "Client",
    invoice: "Invoices",
    dashboard: "Dashboard",
    dashboardGroups: "Groups Dashboard",
    dashboardLimitedInterval: "Limited intervals",
    accounts: "Accounts",
    order: "Orders",
    stock: "Stocks",
    error: "Error",
    bankTransfer: "Bank Transfer",
    offered: "Offered",
    disableCash: "Disable Cash",
    disableCard: "Disable Card",
    kiosk: "Kiosk",
    payment: "Payment",
    customerCredit: "Customer Credit",
    paymentForced: "Forced Payment",
    paymentTransaction: "Payment Transactions",
    analytics: "Analytics",
    admin: "Admin",
    paymentMethod: "Payment Method",
    transactionType: "Transaction Type",
    amountPaid: "Total Paid",
    amountReturned: "Total Returned",
    tip: "Tip",
    rounding: "Rounding",
    none: "None",
    doNotChange: "Leave unchanged",
    detachParent: "Detach from parent",
    cash: "Cash",
    card: "Card",
    free: "Free",
    mixed: "Mixed",
    transfer: "Bank Transfer",
    forceCloseShift: "Force Shift Closure",
    general: "General App",
    appSearchAccounts: "Search Accounts",
    appCorrectPayment: "Correct Payment",
    disableEatIn: "Disable Eat in",
    disableTakeaway: "Disable Takeaway",
    emptyStateTitle: "No Data",
    emptyStateText: "Start a shift to view your dashboard.",
    emptyStateBtn: "Start Shift",
    newVersionReload: "A new version of the admin is available. Please reload the page.",
    serviceDetails: "Service Details",
    hours: "Hours",
    cashRegister: "Cash Register",
    start: "Start",
    end: "End",
    invoicing: "Invoicing",
    invoice_send: "Send",
    invoice_get: "View",
    invoice_all: "Full access",
    invoice_paid: "Mark/View",
    orgType: "Organization type",
    reorganize: "Reorganize",
    done: "Save",
    tabletMode: "Tablet view",
    exitTabletMode: "Exit tablet view",
    subOption: "Sub-options",
    barcode: "Barcode",
    advanced: "Advanced",
    optionProduct: "Product options",
    confirmAction: "Are you sure you want to perform this action?",
    orderAtTable: "ORDER AT TABLE",
    generateCodeQr: "Generate QR code",
    dynamicPrice: "Dynamic price",
    summaryRev: "Change Summary",
    reset: "Reset",
};

const navBarStrings = {
    products: "Products",
    catalog: "Catalog",
    groups: "Groups",
    productOptions: "Option lists",
    home: "Home",
    users: "Users",
    tables: "Tables",
    my_account: "My Account",
    settings: "Settings",
    dashboard: "Dashboard",
    analytics: "Analytics",
    account: "Account",
    image: "Images",
    pickup: "Pickup",
    acitivity: "Acitivity",
    order_history: "Orders",
    account_history: "Accounts",
    shifts: "Shifts",
    shift: "Shift Z",
    payments: "Payments",
    log: "Log",
    logout: "Logout",
    printers: "Printers",
    stock: "Stock",
    clients: "Clients",
    invoice: "Invoices",
    kitchen: "Message",
    promo: "Promotions",
    extIntegration: "Integrations",
    createOrg: "Create an org",
    superUser: "Super User",
    superUsers: "Super Users",
    dashboardSU: "Dashboard SU",
    menu: "Menu",
    importCSV: "Import menu",
    vouchers: "Vouchers",
    searchOrg: "Search an organization",
    noOrgFound: "No organization found",
    icons: "Icons",
    deliveryAreas: "Delivery"
}

const integrationStrings = {
    addInt: "Add integration",
    ipAddress: "Address",
    user: "User",
    protocol: "Protocol",
    localPrint: "Local print",
    serialNumber: 'Serial number',
    webtoolUrl: 'Webtool URL',
    authKey: 'Auth key',
    noIntegration: "No integration",
    noIntegrationHint: "Add an integration to get started.",
    editInt: "Edit integration"
}

const toastStrings = {
    vatTicketSent: "VAT ticket sent",
    groupNameTooShort: "The name must contain at least 3 characters",
    successSave: "Save success",
    errorSave: "Save error",
    successEdit: "Edit success",
    errorEdit: "Edit error",
    createSuccess: "Create success",
    createError: "Create error",
    deleteSuccess: "Delete success",
    deleteError: "Delete error",
    duplicateSuccess: "Duplicate success",
    duplicateError: "Duplicate error",
    copySuccess: "Link copied",
    deleteGroupNotAllowed: "Cannot delete a non-empty group.",
    errorNotSelected: "Please select at least one item",
    cannotDeleteInvoicedAccount: "Cannot delete an already invoiced account.",
    cannotEdit: "Inherited item: some fields are not editable.",
    downloadError: "The download failed, please try again."
};

const loginPageStrings = {
    welcome_back: "Welcome Back",
    login_page_subtitle: "Your perfect restaurant companion always there when you need it",
    login_page_form_title: "Log Back In",
    login_page_form_subtitle: "Enter your login details",
    login_button: "Login"
}

const dashboardStrings = {
    morePeriods: "More",
    organisations: "Organisations",
    devices: "Devices",
    openShifts: "Open shifts",
    orgName: "Organisation name",
    searchOrganisation: "Search an organisation...",
    searchShift: "Search a shift, an organisation...",
    noOrganisation: "No organisation",
    noOpenShift: "No open shift",
    switchToOrg: "Switch to this organisation",
    openShiftDetail: "View shift",
    lastDays: "Last {days} days",
    yoursInfos: "Your establishment",
    empty: "No table is occupied",
    shiftTitle: "Open table",
    openTableText: "Open table",
    takeawayText: "Open takeaway",
    noshiftOpen: "No shift opened",
    takeawayTitle: "Takeaway",
    currentShift: "Current shift",
    latestShift: "Last shift",
    lastShift: "Last shift",
    accountsTotal: "Total accounts",
    accountsTooltip: 'Total number of open AND closed accounts, with at least 1 paid item in the account.',
    remainingUnpaid: "Remaining Un-Paid",
    remainingUnpaidTooltip: "The total amount of ordered items that still need to be paid fully or partially",
    salesPaid: "Sales Paid",
    salesPaidTooltip: "The total amount of paid items in the accounts that are part of the selected shift(s)",
    averageBasket: "Average Basket",
    orgId: "Org ID",
    unnamedOrg: "Unnamed organisation",
};

const productGroupsDashboardStrings = {
    title: "Sales by product group",
    totalRevenue: "Revenue",
    totalRevenueTooltip: "Total revenue (incl. VAT) of all displayed groups",
    quantitySold: "Quantity sold",
    accountCount: "Accounts",
    accountCountTooltip: "Number of distinct accounts (tickets)",
    averageBasket: "Average Basket",
    subGroups: "Sub-groups",
    topProducts: "Top products",
    rushHours: "Rush hours",
    revenueInclVat: "Total sales",
    vatByRate: "VAT by rate",
    vatRate: "Rate",
    vatExcl: "Excl. VAT",
    vatAmount: "VAT",
    vatIncl: "Incl. VAT",
    salesByChannel: "Sales by channel",
    paymentCash: "Cash",
    paymentCard: "Card",
    paymentTransfer: "Transfer",
    discountTotal: "Discounts",
    averagePrice: "Average price",
    details: "Details",
    empty: "No data to display for this period",
    forbidden: "You don't have access to this dashboard",
};

const userPageStrings = {
    createPartialError: "The user was created, but some settings could not be saved: {error}. Edit the user to complete them.",
    kdsCallMode: "KDS Call Screen Mode",
    kdsCallModeTooltip: "When enabled, each order appears in a single state on the kitchen display. An order moves to in-progress as soon as one item is being prepared, and to ready only when all items are completed.",
    userSubscribedProductGroupIds: "Product groups",
    userSubscribedProductGroupIdsTooltip: "The user will only be able to see the selected groups when logged in.",
    userSubscribedZoneId: "Table zones",
    userSubscribedZoneIdTooltip: "The user will only be able to see the selected zones when logged in.",
    username: "Username",
    password: "Password",
    vwMultiMerchantId: "VW Multi Merchant ID",
    vwMultiMerchantIdTooltip: "Identifies the user's merchant account in Viva Wallet multi-merchant setup.",
    type: "User Type",
    pincode: "PIN code",
    vwTerminalIp: "VW Terminal IP",
    vwTerminalId: "VW Terminal ID (cloud)",
    userPrinter: "User Printer",
    selectAbilities: "Select Abilities",
    appMode: "App Mode",
    pincodeTooltip: "The pin code required to unlock the app when pin lock is enabled. This will also allow tracking user actions based on the entered pincode on the main register.",
    userPrinterTooltip: "The printer that will be used for this user. This will override the main printer if set and will allow VAT/Summary tickets to be printed on this printer",
    fullAccess: "Full access",
    userIntegrations: "Integrations",
    userIntegrationsTooltip: "The integrations (cash machine, payment terminal…) linked to this user. Ticking an integration of another user moves it to this one, unticking one deletes it on save.",
    integrationsDeleteWarning: "Warning, these integrations will be deleted on save: {list}",
    kdsSubscribedProductGroupIds: "KDS Product Groups",
    kdsSubscribedProductGroupIdsTooltip: "Assign which product groups will be dispatched to this KDS user, if no groups are assigned, the user will receive all orders.",
    addUser: "Add user",
    niss: "NISS",
    blackboxTester: "Training",
    cannotDeleteAdmin: "This user cannot be deleted",
    duplicate: "Duplicate",
    cannotDuplicateUser: "This user cannot be duplicated",
    duplicateFrom: "Copy of {username}",
    duplicateMissingFields: "Please fill in the username, password and PIN code",
    passwordGenerationRequired: "Please generate a password",
    passwordGeneratePlaceholder: "No password",
    apiDocsPasswordRules: "With API documentation access, the password must contain at least {length} characters, including an uppercase letter, a lowercase letter, a digit and a special character",
    apiDocsPasswordRegenerate: "API documentation access was just added: regenerate the password to get a {length}-character one",
    adminPasswordRules: "The admin password must contain at least {length} characters, including an uppercase letter, a lowercase letter and a special character",
    linkDevice: "Link a device",
    pairingCode: "Pairing code",
    pairingCodePlaceholder: "000000",
    pairingCodeTooltip: "The 6-digit code shown on the device to link. It stays valid for 10 minutes while the device remains on the pairing screen.",
    linkDeviceWarning: "The device will log in with this account without typing a password. A device already linked to this account will have to log in again with its password.",
    linkDeviceWaiting: "Waiting for the device to log in, this can take up to 60 seconds…",
    linkDeviceSuccess: "Device linked successfully",
    linkDeviceError: "The device could not be linked",
    pairingCodeOptional: "Optional",
    pairingCodeEditTooltip: "Enter the 6-digit code shown on the device so it logs in directly with this account on save. A device already linked to this account will have to log in again with its password.",
    pairingCodeInvalid: "The pairing code must contain 6 digits",
    createLinkDeviceError: "The user was created, but the device could not be linked: {error}. Edit the user to enter the code again.",
    scanPairingCode: "Scan the QR code",
    scanPairingCodeInvalid: "This QR code does not contain a pairing code",
    cameraUnavailable: "The camera cannot be accessed. Allow it in the browser settings.",
    cameraRequiresHttps: "The camera is only available on an HTTPS page.",
    linkDeviceUser: "User",
    linkDeviceUserPlaceholder: "Choose a user"
}

const superUserPageStrings = {
    validation: {
        username: "The username is required",
        email: "The email is required"
    },
    createTitle: "Create Super User",
    editTitle: "Edit Super User",
    addSuperUser: "Add a super user",
    username: "Username",
    usernameHint: "Must start with su_",
    email: "Email",
    phoneNumber: "Phone Number",
    partnerSource: "Partner Source",
    abilities: "Abilities",
    abilityCreateOrg: "Create Organization",
    abilityCreateUser: "Create Super User",
    abilityViewApiDocs: "API documentation access",
    regenerate: "Regenerate",
    regeneratePassword: "Regenerate password",
    regeneratePasswordConfirm: "Regenerate the password for {username}?<br>It will be sent to {email}.",
    deleteConfirm: "Are you sure you want to delete {username}?<br> This action cannot be undone."
}

const productGroupPageStrings = {
    deleteBlocked: "Cannot delete: these groups still contain products or subgroups that are not selected: {groups}",
    addSubGroup: "Add sub group",
    productGroups: "Product Groups",
    addGroup: "Add Group",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    searchGroup: "Search a group",
    noParent: "None (standalone group)",
    manageSubGroups: "Manage sub-groups",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    vatIn: "Vat In",
    vatOut: "Vat Out",
    printerIp: "Printer Ip Address",
    name: "Name",
    userHidden: "Hide on app?",
    webHidden: "Hide on website?",
    isHidden: "Hidden in app",
    isNotHidden: "Shown in app",
    KitchenPrintEnabled: "Print",
    groupOrder: "Group order",
    loadingResultTable: "Loading data. Please wait.",
    color: "Colors",
    assignToAllProduct: "Assign to all products",
    assignToAllProductTooltip: "Enable this option to assign this group to all your products",
    assignVatToAllProducts: "Assign VAT to all products",
    assignVatToAllProductTooltip: "Enable this option to assign this group's VAT to all products",
    vatTooltip: "A VAT that will be suggested when this group is assigned to a product. Changing this will not change VATs of products in this group",
    orderTooltip: "Order of the group in the list, this will be used to sort the groups by ascending order",
    kitchenPrintEnabledTooltip: "Enable/Disable the printing of orders on the assigned printer for products of this group",
    userHiddenTooltip: "Hide this group from the user interface preventing direct orders of products from this group, but still allow it to be used for product paid/free options",
    hideNameOnKiosk: "Hide name on kiosk",
    hideNameOnKioskTooltip: "Hides this group's name on the kiosk so only its image or icon is shown. The group stays visible and selectable.",
    maxChoicePaid: "Max paid in sub group",
    maxChoiceFree: "Max free in sub group",
    optionOrderTooltip: "Order of this group when it is used as an option for a product",
    maxChoicePaidToolTip: "When attaching this group to a product you can add a number of maximum paid product to select in the flow.",
    maxChoiceFreeToolTip: "When attaching this group to a product you can add a number of maximum free product to select in the flow.",
    activeHours: "Happy Hours",
    activeHoursToolTip: "Enable to define a time slot during which this group will be visible and available for sale in the POS.",
    printOnAllPrinters: "Print on all printers",
    printOnAllPrintersTooltip: "If enabled, products from this group will be printed on all group assigned printers instead of prompting user to select a printer at order time.",
    forcedChoiceAmountFree: "Required free choices",
    forcedChoiceAmountFreeTooltip: "Exact number of free options to select.",
    forcedChoiceAmountPaid: "Required paid choices",
    forcedChoiceAmountPaidTooltip: "Exact number of paid options to select.",
    allowMultipleChoiceOnSameItems: "Allow duplicate sub-option choices",
    allowMultipleChoiceOnSameItemsTooltip: "Allows selecting the same sub-option multiple times for a single product.",
    enablePopup18: "Enable 18+ Popup",
    enablePopup: "Enable custom Popup",
    enablePopupToolTip: "Shows a custom popup when a product of this group is selected",
    picto: "Picto",
    enablePopupTooltip: "Enable/Disable to display an popup for this group on your website.",
    enablePopup18Tooltip: "Enable/Disable to display an age verification popup for this group on your website.",
    descriptionPopup: "Popup text"
}

const catalogPageStrings = {
    exportProducts: "Export the products",
    exportTemplate: "Export the template",
    exportLegacy: "Export (Legacy)",
    openGroup: "Open the group",
    showProducts: "Show products",
    hideProducts: "Hide products",
    expandGroup: "Expand the group",
    collapseGroup: "Collapse the group",
    productsCount: "no product | 1 product | {count} products",
    subgroupsCount: "no subgroup | 1 subgroup | {count} subgroups",
    itemsCount: "no item | {count} item | {count} items",
    moveSelection: "Move the selection ({count})",
    inheritedSelectionDisabled: "Selection is disabled for items inherited from the parent organisation",
    editGroups: "Edit the group | Edit the {count} groups",
    deleteGroups: "Delete the group | Delete the {count} groups",
    editProducts: "Edit the product | Edit the {count} products",
    deleteProducts: "Delete the product | Delete the {count} products",
    downloadSelection: "Download ({count})",
}

const productOptionsPageStrings = {
    duplicateList: "Duplicate the list",
    duplicateWithItems: "Include the list's options in the duplicate?",
    copyName: "{name} (copy)",
    name: "Option lists",
    addList: "Create a list",
    searchPlaceholder: "Search a list",
    empty: "No option list",
    nameFR: "Name (FR)",
    nameNL: "Name (NL)",
    nameBase: "Name (base)",
    minChoiceTotal: "Minimum choices",
    maxChoiceTotal: "Maximum choices",
    forceChoiceTotal: "Forced choices",
    minChoiceTotalTooltip: "Minimum number of options to pick in this list",
    maxChoiceTotalTooltip: "Maximum number of options to pick in this list",
    forceChoiceTotalTooltip: "Exact number of options to pick in this list",
    forceOverridesMinMax: "A number of choices is forced: the minimum and the maximum no longer apply.",
    newList: "New list",
    createList: "Create the list",
    selectListHint: "Select a list or create a new one",
    sectionName: "Name",
    sectionRules: "Choice rules",
    sectionProducts: "Products",
    sectionPrice: "Price",
    sectionSettings: "Settings",
    free: "Free",
    freeTooltip: "This option will be considered free when taking an order",
    multiple: "Multiple",
    price: "Price",
    priceInOut: "Price In/Out",
    priceOnSite: "On site price",
    priceTakeaway: "Takeaway price",
    priceTooltip: "Option price; leave empty to keep the normal product price",
    priceTakeawayTooltip: "Takeaway option price; leave empty to keep the normal product price",
    pricePerPlatform: "Price per platform (In/Out)",
    pricePerPlatformTooltip: "On site and takeaway price per platform; leave empty to keep the normal product price",
    typeLabel: "Option type",
    typePrefix: "Prefix",
    actionsTooltip: "Reorder, edit or remove the option",
    typeTooltip: "Special option type, e.g. \"Without\" to remove an ingredient",
    unsavedChangesConfirm: "Some changes are not saved. Do you want to discard them?",
    productsCount: "no product | {count} product | {count} products",
    addExistingProduct: "Add an existing product",
    createProduct: "New product",
    createGroup: "New group",
    otherGroup: "Others",
    noItems: "No option in this list",
    inherited: "Inherited",
    inheritedTooltip: "List inherited from the parent organisation: read only",
    typeWith: "With",
    typeWithout: "Without",
    allowMultipleChoice: "Multiple choice allowed",
    allowMultipleChoiceTooltip: "The option can be picked several times in the same order",
    maxChoice: "Maximum number of times",
    maxChoiceTooltip: "Maximum number of times this option can be picked in an order",
    includeOptionLists: "Include the product's option lists",
    includeOptionListsTooltip: "The product's own option lists are also offered when this option is picked",
    validation: {
        name: "At least one name is required",
        minMax: "The minimum must be lower than or equal to the maximum",
        negative: "Values must be positive"
    }
};

const productPageStrings = {
    zeroVatConfirm: "This product has 0% VAT. Are you sure you want to save it with 0% VAT?",
    zeroVatConfirmMany: "{count} product(s) have 0% VAT. Are you sure you want to save them with 0% VAT?",
    favorite: "Favorite",
    ingredient: "Ingredient",
    optionLists: "Option lists",
    addOptionLists: "Assign options",
    priceBasis: "Base price on",
    priceBasisTooltip: "Copies each product's chosen price into the other price. Useful when only the eat-in price is filled in.",
    priceBasisIn: "Eat-in price",
    priceBasisOut: "Takeaway price",
    visibilityApp: "Visible on register",
    name: "Product Name",
    products: "Products",
    addProduct: "Add Product",
    noProductInGroup: "No product in this group",
    priceVatInclIn: "Price In",
    priceVatInclOut: "Price Out",
    vatIn: "Vat In",
    vatOut: "Vat Out",
    codeBarre: "Barcode",
    description: "Description",
    stock: "Stock",
    productGroup: "Product Group",
    productGroupParent: "Group Parent",
    productGroupOptions: "Product Group Options Free",
    productGroupOptionsPaid: "Product Group Options Paid",
    productFilterByCategory: "Filter by category",
    timedproduct: "Timed product?",
    allowDecimal: "Allow decimal units?",
    dynamicPrice: "Dynamic price?",
    multiChoice: "Multi choice allowed?",
    orderIndex: "Order",
    optionOrderIndex: "Option Order",
    weightPrice: "Weight Price?",
    visibility: "App Visibility ",
    visibilityWeb: "Web Visibility",
    visibilityKiosk: "Kiosk Visibility",
    userHiddenTooltip: "Hide this product from the user interface preventing direct orders of this product, but still allow it to be used for product paid/free options",
    imageUrl: "Main image URL in https",
    extraImageUrls: "Extra image URLs in https",
    extraImageUrlsTooltip: "Enter your extra image URLs, which will be used to show the product images on your website. Make sure to separate each URL with a comma and also end with a comma.",
    allergens: "Allergens",
    color: "Color",
    orderTooltip: "Order of the product in the list, this will be used to sort the products of the same group by ascending order",
    timedProductTooltip: "When enabled, this product will start a timer when ordered and on close will use the product price as a price/minute to compute the total price",
    allowDecimalTooltip: "Will allow the user to enter a decimal value for the quantity of the product on long click before ordering or before sending by selecting product > units",
    dynamicPriceTooltip: "This will ignore the above price and require the user to enter a price when this product is selected",
    weightPriceTooltip: "This will require the user to enter a weight in KG when this product is selected. It will detect the weight automatically if a scale is connected",
    promo_percent: "Fixed promotion in %",
    webHiddenTooltip: "Hide this group from the web interface preventing direct orders of products from this group, but still allow it to be used for product paid/free options",
    tags: "Tags",
    parentProduct: "Online Order Parent Product",
    parentProductTooltip: "This product is a child of the selected product and will appear as an option in the online order platform",
    tagsTooltip: "Enter your tags, which will be used to filter your products on your website. Make sure to separate each tag with a comma.",
    enterBarcode: "Enter barcode",
    externalReference: "External reference",
    externalReferenceTooltip: "Reference used to link this product/group to an item from another platform or external system.",
    kioskHidden: "Hidden on kiosk?",
    kioskHiddenTooltip: "Enable this option to hide this product/group only on your kiosk.",
    purchasePriceVatExcl: "Purchase price",
    optionsDescription: "Custom options description",
    optionsDescriptionTooltip: "Set custom options description that should be shown under the product name instead of the default options (assigned sub options group names)",
}

const stockPageStrings = {
    emptyTable: "No history found.",
    name: "Product Name",
    stock: "Stock",
    productGroup: "Product Group",
    productGroupOptions: "Product Group Options Free",
    productGroupOptionsPaid: "Product Group Options Paid",
    productFilterByCategory: "Filter by category",
    timedproduct: "Timed product?",
    allowDecimal: "Allow decimal?",
    newStock: "New stock",
    stockVariation: "Stock variation",
    editedBy: "Edited by"
}

const kitchenPageStrings = {
    name: "Kitchen Message",
    addMessage: "Create message",
    message: "Message",
    textEnter: "Message: ",
    erText: 'Message required',
    noFundResultTable: "No message found.",
}

const imagePageStrings = {
    name: "Media",
    addImage: "Add media",
    textEnter: "Enter url : ",
    textUpload: "Drag and drop your media here or click to add",
    fileTooLarge: "The file exceeds the 2MB size limit",
    limit: "The file exceeds the 2MB size limit",
    allTypes: "All types",
    imagesOnly: "Images",
    videosOnly: "Videos",
    addSuccess: "{count} media added",
    addError: "{count} media could not be added",
    uploadLimits: "Images up to {image} MB, videos up to {video} MB",
    noMedia: "No media",
    noMediaHint: "Add an image or a video to get started.",
    type: "Type",
    video: "Video"
}

const iconsPageStrings = {
    name: "Icons",
    addIcon: "Add icon",
    internalName: "Internal name",
    nameFR: "Name (FR)",
    nameNL: "Name (NL)",
    nameEN: "Name (EN)",
    searchPlaceholder: "Search an icon",
    empty: "No icons found",
    preview: "Preview",
    category: "Category",
    url: "URL",
    allCategories: "All categories",
    group: "Group",
    ingredient: "Ingredient",
    textUpload: "Drag and drop your icons here or click to add",
    addSuccess: "{count} icon(s) added",
    addError: "{count} icon(s) could not be added",
    categoryValues: {
        GROUP: "Group",
        ALLERGEN: "Allergen"
    },
    validation: {
        name: "Name is required",
        url: "URL is required",
        file: "Image is required",
        category: "Category is required",
        duplicateName: "This name is used more than once"
    }
}


const tableStrings = {
    name: "Tables",
    addTable: "Add Table",
    nameZones: "Zones",
    selectZone: "Select zones",
    addZones: "Add a zone",
    addTableZone: "Add a table zone",
    nameTypes: "Types",
    selectType: "Select types",
    addTypes: "Add a table type",
    tableNumber: "Table Number",
    zoneNumber: "Zone Number",
    zoneName: "Zone Name",
    typeName: "Type Name",
    qrAllTables: "Download as ZIP ({count} table) | Download as ZIP ({count} tables)",
    qrNoTables: "No table to generate",
    createZone: "Create a zone",
    editZone: "Edit zone",
    noZone: "No zone",
    tableCount: "{count} table | {count} tables",
    emptyTables: "No tables",
    invalidColor: "Invalid color, use the #RRGGBB format"
}


const clientStrings = {
    emptyTable: "No customers found.",
    addClient: "Add Client",
    name : "Name",
    phone: "Phone Number",
    street: "Street",
    city: "City",
    extra: "Extra Info",
    zipCode: "Zip Code",
    number: "Number",
    box: "Box",
    business: "Business",
    vat: "VAT number",
    email: "Email",
    erZipCode: "Zip code is required",
    erNumber: "Number is required",
    erName: "Name is required",
    erPhone: "Phone number is required",
    erStreet: "Street is required",
    erCity: "City is required",
    erPhone2: "Phone number is not valid",
    erBox: "Box is required",
    erMail: "Email is required",
    erMail2: "Email is not valid",
    erBusiness: "Business is required",
    erVat2: "VAT is not valid",
    editClient: "Edit client",
}

const paymentsStrings = {
    header: "Payment Transactions",
    orderId: "Order ID",
    paymentType: "Type",
    amount: "Amount",
    returned: "Returned",
    totalCash: "Total Cash",
    totalCard: "Total Card",
    totalOffered: "Total Offered",
    totalError: "Total Error",
    totalVatExcl: "HVAT",
    totalCredit: "Total Credit",
    totalVatIncl: "Total",
    vatValue: "Value",
    totalBankTransfer: "Total Transfer"
}

const orderedProductsString = {
    header: "Order History",
    accountId: "Account ID",
    linkedTo: "Linked To"
}

const accountHistory = {
    orderCode: "Code",
    payType: "Payment",
    source: "Source",
    header: "Accounts History",
    filterShift: "Shift #{shiftId}",
    filterUser: "User #{userId}"
}

const openAccounts = {
    header: "Open Accounts",
    type: "Type",
    source: "Source",
    orderCode: "Order Code",
    covers: "Covers",
    duration: "Duration"
}

const shiftDetail = {
    header: "Shift detail",
    referenceId: "Reference"
}

const shiftStat = {
    header: "Shift statistic",
    sectionUsers: "Users",
    sectionUserShifts: "Shifts per user",
    sectionGroups: "Groups",
    sectionParentGroups: "Parent groups",
    sectionProducts: "Products",
    count: "Quantity",
    sales: "Sales",
    refund: "Refunds",
    correction: "Corrections",
    otherNeg: "Other negative",
    purchasePrice: "Purchase price",
    vatDetails: "VAT details",
    totalShifts: "Number of shifts",
    userType: "Type",
    duration: "Duration",
    shift: "Shift",
    autoClosed: "Auto close"
}

const shift = {
    openShift: "Open time",
    openUserName: "Open user",
    openUserTime: "Open time",
    openUserCash: "Start cash",
    closeUserName: "Close user",
    closeUserTime: "Close time ",
    closeUserCash: "End cash",
    totalCash: "Cash",
    totalCard: "Card",
    totalOffered: "Offered",
    totalBankTransfer: "Transfer",
    totalError: "Error",
    totalCredit: "Credit",
    statistics: "Statistics",
    total: "Total shift",
    inProgress: "In progress...",
    endComment: "Any comment about the end shift",
    paymentType: "Force to close the account with mixed payment by",
    totalCashClose: "Your total amount of cash",
    HeaderShiftClose: "Close this shift",
    MessageCloseShift: "Are you sure you want to end the shift? You can't open this shift afterwards !",
    MessageOpenShift: "Are you sure you want to open a new shift?",
    noOpenShift: "No shift in progress",
    OpenNewShift: "Open a new shift?",
    OpenNewShiftButton: "Open a shift",
    training: "Training",
};

const printerStrings = {
    printers: "Printers",
    addPrinter: "Add printer",
    printerName: "Printer name",
    doublePrint: "Print double",
    model: "Model",
    modelUnset: "-- Select model --",
    modelHelper: "Star printer model. Optional — leave empty if unknown.",
    erName: "Name required",
    erIpAddress: "IP address required",
    modelGroup: {
        desktop: "Desktop / countertop",
        compact: "Compact / kitchen / kiosk",
        mobile: "Mobile"
    },
    noPrinter: "No printer",
    noPrinterHint: "Add a printer to get started.",
    editPrinter: "Edit printer",
}

const settingsPageStrings = {
    searchPlaceholder: "Search a setting...",
    status: "Organization Status",
    settings: "Settings",
    orderConfirmationEmailBccEnabled: "Receive order confirmation emails as a BCC",
    orderConfirmationEmailBccEnabledTooltip: "Enable this option to receive a blind carbon copy (BCC) of all order confirmation emails sent to customers.",
    hasImageBackground: "Product image has background",
    printProductsSectionOnZReport: "Print products section on Z report",
    printProductsSectionOnZReportTooltip: "Include the products section on the Z report when the shift is closed.",
    digitalVatTicketEnabled: "Digital VAT Ticket",
    digitalVatTicketEnabledTooltip: "Enable digital VAT ticket generation for this organization",
    printStatusUrlQrCode: "Print status QR code",
    printStatusUrlQrCodeTooltip: "Print a QR code on tickets and kiosk screens so customers can track their order status online.",
    masterKioskOrgEnabled: "Master kiosk mode",
    masterKioskOrgEnabledTooltip: "Tooltip Allow kiosk devices to switch between child organizations (e.g. food court tenants).",
    masterKioskIncludeMasterInPicker: "Include master org in kiosk picker",
    masterKioskIncludeMasterInPickerTooltip: "Show this organization as a selectable option in the kiosk switching screen, alongside child organizations.",

    dataChangeLock: "Lock data modifications",
    dataChangeLockTooltip: "When enabled, only super users can modify the organization's basic settings.",
    partnerSource: "Partner source",
    partnerSourceTooltip: "Identifies the partner/reseller this organization belongs to. Only super users with the same partner source can manage this organization; leave empty for a globally managed organization.",
    supportChatCrispEnabled: "Crisp support chat",
    supportChatCrispEnabledTooltip: "Shows the Crisp chat widget to this organization so they can contact support directly from the app. Turn it off to hide the widget for this client.",
    supportVipEnabled: "VIP support",
    supportVipEnabledTooltip: "Flags this organization as a priority client so their support requests are handled first.",
    kioskOrderActive: "Enable kiosk orders",
    kioskOrderActiveTooltip: "By enabling this option, customers will be able to place orders from the kiosk.",
    vwActivationMerchantApiKey: "Viva Wallet Activation Merchant API Key",
    vwActivationMerchantApiSecret: "Viva Wallet Activation Merchant API Secret",
    vwActivationPin: "Viva Wallet Activation PIN",
    shiftCounterEnabled: "Enable Per-Shift Ticket Counter",
    shiftCounterEnabledTooltip: "When enabled, ticket counters reset automatically at the end of each shift.",
    brandColors: "Brand colors",
    brandColor: "Brand color",
    brandSecondaryColor: "Brand secondary color",
    brandTertiaryColor: "Brand tertiary color",
    applyKioskBrandColors: "Apply brand colors on kiosk",
    applyKioskBrandColorsTooltip: "When enabled, the kiosk uses your brand colors instead of the default theme.",
    onlineOrderVersion: "Online Order version",
    bank: "Bank",
    suSectionOrganisation: "Organization",
    suSectionPeppol: "Peppol",
    suSectionKitchenDisplay: "Kitchen display",
    suSectionDigitalMenu: "Digital menu",
    suSectionWebshop: "Webshop",
    suSectionGoogleMaps: "Google Maps",
    suSectionDeviceManagement: "Device management",
    suSectionShiftUser: "Worker shifts",
    suSectionParentOrganisation: "Parent organization",
    bankIban: "IBAN",
    bankName: "Name",
    bankBic: "BIC code",
    peppolEnabled: "Enable Peppol",
    peppolEnabledTooltip: "Enable the Peppol integration to send and receive compatible electronic documents.",
    name: "Your Organisation",
    organisationId: "Organisation code",
    organisationName: "Name",
    vatNumber: "VAT number",
    digitalMenuEnabled: "Enable digital menu",
    digitalMenuEnabledTooltip: "Enable the digital menu linked to this organization on supported channels.",
    address: "Address",
    searchAddress: "Search your address (street and number)",
    noAddressFound: "No address found",
    addressWithoutNumber: "Please include your street number in the search",
    selectAddressFromList: "Please select your address from the suggestions",
    addressSearchUnavailable: "Address search is currently unavailable",
    telephone: "Telephone",
    contactEmail: "Contact email",
    autoPrintVatTicketOnSend: "Auto print VAT ticket on send",
    autoPrintVatTicketOnSendTooltip: "Enable to automatically print the VAT ticket after an order is sent",
    website: "Website",
    mainPrinterIpAddress: "Main printer IP Address",
    takeawaySectionEnabled: "Takeaway section enabled",
    takeawaySectionEnabledTooltip: "Enable a dedicated takeaway section on the home screen.",
    tableSectionEnabled: "Table section enabled",
    tableSectionEnabledTooltip: "Enable a dedicated tables section on the home screen.",
    shiftEnabled: "Shift enabled",
    printerSettings: "Printing",
    vivaWallet: "Viva Wallet",
    removeStockFromParentOrgHint: "Remove stock from parent organization on order",
    removeStockFromParentOrgTooltip: "Enable this option to automatically deduct stock from the parent organization when an order is placed.",
    webSettings: "Web order settings",
    superSettings: "Super user",
    kitchenTopSpacing: "Kitchen top spacing",
    kitchenTopSpacingTooltip: "Adjust the spacing above the kitchen area to improve visual comfort.",
    kitchenGroupItems: "Kitchen group items",
    kitchenGroupItemsTooltip: "When enabled, kitchen items are grouped together for a cleaner display.",
    charactersPerLine: "Characters per line",
    charactersPerLineTooltip: "Set the maximum number of characters allowed per printed line.",
    bigKitchenFontSize: "Big font size for kitchen",
    bigKitchenFontSizeTooltip: "Increase the kitchen font size to improve readability.",
    pinLockTimeout: "Pin lock timeout (seconde)",
    promptCoversEnabled: "Ask for number of covers",
    promptCoversEnabledTooltip: "When opening a table or order, staff are asked how many guests are seated.",
    pinLockEnabled: "Pin lock",
    kitchenPrintEnabled: "Print order ticket",
    autoCloseAccountOnPaymentEnabled: "Close account after payment",
    kioskAutoCloseAccountOnPaymentEnabled: "Auto-close kiosk orders on payment",
    kioskAutoCloseAccountOnPaymentEnabledTooltip: "Kiosk orders paid at the kiosk are closed right away instead of staying in the paid accounts list.",
    onlineOrderAutoCloseAccountOnPaymentEnabled: "Auto-close online orders on payment",
    onlineOrderAutoCloseAccountOnPaymentEnabledTooltip: "Web orders paid online are closed right away instead of staying in the paid accounts list.",
    autoPrintSummaryTicketEnabled: "Auto print ticket after payment",
    autoPrintKioskTooltip: "Auto print a summary ticket after a payment on the kiosk",
    autoPrintOnlineOrderTooltip: "Auto print a summary ticket after a payment on the webshop",
    autoPrintShiftXY: "Auto print Z",
    hideShiftInfo: "Hide shift info",
    paymentTypeOfferedEnabled: "Allow offered payment type",
    paymentTypeTransferEnabled: "Allow bank transfer payment type",
    sendOrderBehavior: "Action After send",
    autoOpenCashRegister: "Open cash register automatically",
    DEFAULT: "DEFAULT",
    NAV_BACK: "RETURN",
    NAV_PAYMENT: "GO PAYMENT",
    orgaFlag: "App",
    refundEnabled: "Allow Refund",
    addItemsToTop: "New product on top",
    autoOpenNewAccount: "Auto open new account",
    normalAccountOpenButton: "Normal '+' button to open an account",
    vwIsvAmount: "ISV Amount",
    vwEnabled: "VW Enabled",
    vwTerminalMerchantId: "ISV Merchant ID",
    vwTerminalId: "Terminal ID (For NEXT terminals)",
    mapsAutoCompleteEnabled: "Google Maps Integration",
    autoAssignDeviceToMainType: "Auto assign device to main type",
    workerShiftsEnabled: "Enable user shift (User time)",
    pinLockTooltip: "Require a pin code to access the app",
    shiftsTooltip: "Enable the shift system, this will require the user to open a shift before using the app and close it at the end of each shift",
    printOrderTicketTooltip: "Enable the printing of a ticket when an order is sent to the kitchen",
    closeAccountAfterPaymentTooltip: "Automatically close the account after a payment",
    autoPrintSummaryTicketTooltip: "Automatically print a summary ticket after a payment",
    autoPrintSummaryOnCashOrderKiosk: "Automatically print the ticket after a Cash payment on the kiosk",
    autoPrintSummaryOnCashOrderOnlineOrder: "Automatically print the ticket after a Cash payment on the webshop",
    allowOfferTooltip: "Enables the offer button on the payment screen for ALL users",
    actionAfterSendTooltip: `Choose what happens after an order is sent to the kitchen : 
 - DEFAULT: Stay on the order screen 
 - RETURN: Go back to the order screen 
 - GO PAYMENT: Go to the payment screen`,
    openCashRegisterTooltip: "Automatically open the cash register when a payment is made in cash upon payment confirmation",
    autoPrintShiftXZTooltip: "Automatically print the X/Z on the printer when the shift is closed in the application",
    hideShiftInfoTooltip: "Hide the shift information such as the payment type and the total amount of the shift on the shift management page in the application",
    allowBankTransferTooltip: "Enable the bank transfer payment method on the payment screen for ALL users",
    allowRefundTooltip: "Enable the refund button in an account from the history for ALL users",
    newProductOnTopTooltip: "When enabled, a product is added to an account/table it will appear at the top of the list instead of the bottom",
    autoOpenNewAccountTooltip: "Automatically open a new account when the last one is closed. This will allow for direct order taking after the previous account is closed.",
    separateInDeliveryTakeawayTooltip: `Disabled : this will provide 2 types of account open buttons on the home screen, delivery/takeaway and table.
     Enabled : This will provide only a '+' button to open a new account`,
    subSectionPayment: "Payment",
    subSectionHome: "Home Screen",
    subSectionShift: "Shift",
    subSectionOrdering: "Ordering",
    subSectionWebsite: "Website",
    mainPrinterTooltip: "The main printer ip address where all tickets will be printed by default",
    pinLockTimeoutTooltip: "The time in seconds before the pin lock is activated. This will only work if the pin lock flag is enabled",
    includeParentProductsHint: "Include parent products",
    includeParentProductsTooltip: "Includes products of the parent organizations ONLY on the app if this organization has a parent",
    parentOrgId: "Parent organization ID",
    parentOrgIdTooltip: "Defines the parent organization used to inherit certain settings, products, or behaviors.",
    onlineOrderWebPageEnabled: "Online order activated",
    onlineOrderWebPageEnabledTooltip: "Enable the online ordering webshop for this organization.",
    onlineOrderOpen: "Online order open",
    onlineOrderOpenTooltip: "Temporarily enable or disable order intake on the webshop without disabling the entire online ordering site.",
    onlineOrderDeliveryEnabled: "Delivery enabled",
    onlineOrderDeliveryEnabledTooltip: "Allow customers to choose delivery as an order mode on the webshop.",
    onlineOrderPickupEnabled: "Pickup enabled",
    onlineOrderPickupEnabledTooltip: "Allow customers to choose pickup as an order mode on the webshop.",
    payOnlineEnabled: "Online payment enabled",
    payOnlineEnabledTooltip: "Enable online payment during webshop checkout.",
    payAtPickupEnabled: "Pay after order (at pickup) enabled",
    payAtPickupEnabledTooltip: "Allow customers to pay on pickup or delivery instead of paying online when placing the order.",
    onlineOrderHideNoStockProducts: "Show product with stock available only",
    onlineOrderHideNoStockProductsTooltip: "Hide out-of-stock products from the webshop.",
    logoImageUrl: "Logo",
    logoImageUrlTooltip: "Your organization's logo. Upload a PNG or paste its URL.",
    ticketLogoImageUrl: "Ticket logo (png)",
    ticketLogoImageUrlTooltip: "Logo printed on tickets. Upload a PNG or paste its URL.",
    bannerImageUrl: "Banner",
    bannerImageUrlTooltip: "Banner shown on your online shop. Upload an image or paste its URL.",
    hideProductImagesInApp: "Hide pictures on APP",
    hideProductImagesInAppTooltip: "If you have placed images on your products, this allows them not to be displayed on the posbel application, but to keep the images visible for your QR-CODE/KIOSK/...",
    webOrgaName: "Organisation name for the website",
    autoPrintSummaryTicketOnSend: "Auto Print Summary Ticket after an order is sent",
    autoPrintSummaryTicketOnSendTooltip: "Enable to automatically print the summary ticket when an order is sent",
    autoPrintVatTicket: "Auto print VAT ticket",
    autoPrintVatTicketTooltip: "Enable to always print automaticaly the VAT ticket after a payment",
    subscriptionEnd: "Subscription end",
    subscriptionEndTooltip: "Defines the date and time when the organization's subscription ends.",
    onlineOrderMinAmount: "Minimum amount for online order",
    onlineOrderMinAmountTooltip: "Minimum order amount required for customers to validate a webshop order.",
    onlineOrderPromoCodeInputEnabled: "Promo code field",
    onlineOrderPromoCodeInputEnabledTooltip: "Shows the promo code input on the webshop when validating the order.",
    onlineOrderExecutionTimeInputEnabled: "Order time selection",
    onlineOrderExecutionTimeInputEnabledTooltip: "Lets the customer choose the execution time of the order on the webshop.",
    onlineOrderExecutionTimeEatInEnabled: "Eat-in time selection",
    onlineOrderExecutionTimeEatInEnabledTooltip: "Also allows choosing the execution time for eat-in orders.",
    onlineOrderMinExecutionDelayMinutes: "Minimum execution delay (minutes)",
    onlineOrderMinExecutionDelayMinutesTooltip: "Minimum delay in minutes between order validation and the earliest execution time offered.",
    accountBankName: "Bank account",
    eatInEnabled: "Eat-in",
    eatInEnabledTooltip: "Allow customers to choose dine-in as an order mode on the webshop.",
    autoGroupingEnabled: "Enable Product Grouping",
    autoGroupingEnabledTooltip: "When enabled, items ordered consecutively will be automatically grouped into a single line (e.g., 3 × Item A) to make the order display cleaner and more organized.",
    onlineOrderBankTransferEnabled:"Pay by bank transfer",
    onlineOrderBankTransferEnabledTooltip: "Allow bank transfer as a payment method for webshop orders.",
    kiosk: "Kiosk",
    kioskBackgroundVideoUrl: "URL Background vidéo",
    kioskBackgroundVideoUrlTooltip: "Video played in the background of the kiosk. Upload an MP4 or paste its URL.",
    customWebshopDomain: "Custom website domain",
    customWebshopDomainTooltip: "Assign a custom domain name to this organization's webshop.",
    shiftAutoOpen: "Automatic shift opening",
    shiftAutoOpenTooltip: "Enable this option to automatically open your shift",
    shiftAutoClose: "Automatic shift closure",
    shiftAutoCloseTooltip: "Enable this option to automatically close your shift",
    showShiftHours: "Set automatic closing hours",
    uiStateOrderProductGroupDoubleCols: "Display groups in two columns",
    uiStateOrderProductGroupDoubleColsTooltip: "When enabled, the product groups on your checkout will be displayed in two columns instead of one.",
    kitchenDisplayEnabled: "Enable kitchen display",
    kitchenDisplayEnabledTooltip: "Enable the kitchen display to show orders in preparation for this organization.",
    kitchenDisplayAutoPrintOnStateChange: "Auto print when order is completed",
    kitchenDisplayAutoPrintOnStateChangeTooltip: "When enabled, a ticket is automatically printed as soon as an order reaches the 'Completed' status.",
    kitchenDisplayPreparingStateEnabled: "Enable preparation section",
    kitchenDisplayPreparingStateEnabledTooltip: "When enabled, a 'Preparation' section is displayed to view orders that are currently being prepared.",
    kioskOrderNameRequired: "Ask for the customer's name",
    kioskOrderNameRequiredTooltip: "When enabled, a section will appear to record the customer's name on the order ticket",
    kioskBuzzerNumberRequired: "Ask for the buzzer number",
    kioskBuzzerNumberRequiredTooltip: "When enabled, a section will appear to record the buzzer number on the order ticket",
    active: "Active",
    blocked: "Blocked",
    behindPayment: "Behind payment",
    inactive: "Inactive",
    statusTooltip: "Defines whether the organization is active or blocked in the system.",
    printPhoneOnTicket: "Print phone number on ticket",
    printPhoneOnTicketTooltip: "Print the organization telephone number on Proforma and VAT tickets",
    ticketHeaderText: "Ticket header text",
    ticketHeaderTextTooltip: "Text printed at the top of every ticket, above the order details. Use it for a welcome message or your opening hours. Maximum 500 characters.",
    ticketFooterText: "Ticket footer text",
    ticketFooterTextTooltip: "Text printed at the bottom of every ticket, below the total. Use it to thank customers or share your website. Maximum 500 characters.",
    compressedTicketsEnabled: "Compressed tickets",
    compressedTicketsEnabledTooltip: "Print tickets in a compressed layout to save paper for this organization.",
    showDefaultOptionsDescription: "Show default options (Kiosk/web)",
    showDefaultOptionsDescriptionTooltip: "When enabled, the option groups of the product will be displayed under the product name. This is only applied to kiosk/web ordering. Cash register ordering displays the default options.",
    onlineOrderVersionTooltip: "Select the version to use for your online ordering system.",
    hasImageBackgroundTooltip: "Defines the image style for a better visual rendering on the webshop",
    vwEnabledTooltip: "Enable the Viva Wallet integration for this organization.",
    vwIsvAmountTooltip: "ISV amount or rate used in this organization's Viva Wallet configuration.",
    vwTerminalMerchantIdTooltip: "Merchant identifier used to link this organization to its Viva Wallet account.",
    vwTerminalIdTooltip: "Viva Wallet terminal identifier used for cloud/NEXT payments.",
    vwActivationMerchantApiKeyTooltip: "Merchant API key used to activate Viva Wallet terminals.",
    vwActivationMerchantApiSecretTooltip: "Merchant API secret used to activate Viva Wallet terminals.",
    vwActivationPinTooltip: "Activation PIN provided by Viva Wallet to initialize the terminal.",
    orgTypeTooltip: "Defines the organization's main business category to adapt certain behaviors and displays.",
    mapsAutoCompleteEnabledTooltip: "Enable Google Maps integration for address autocomplete and location assistance.",
    autoAssignDeviceToMainTypeTooltip: "Automatically assign new devices to the main type configured for this organization.",
    workerShiftsEnabledTooltip: "Enable user shift tracking and time-clock behavior for this organization.",
    webOrgaNameTooltip: "Identifier or name used by the webshop site to resolve this organization.",
    blackbox: "Blackbox",
    fdmPosId: "Pos Id",
    fdmUrl: "FDM URL",
    blackboxFdmId: "FDM ID",
    blackboxBasicAuth: "FDM Basic Auth",
    blackboxEstablishmentNumber: "Establishment number",
    generateCodeQrTooltip: "Download the QR code that opens your online ordering website.",
};
const invoicePageStrings = {
    emptyTable: "No invoices found.",
    invoiceNumber: 'Invoice no.',
    linkedTicket: 'Linked ticket',
    type: 'Type',
    standard: 'Standard',
    markAsPaid: 'Mark as paid',
    sentReminder: 'Send reminder',
    paid: 'Paid',
    waiting: 'Pending',
    lastReminder: 'Last reminder',
    markPaidQuestion: 'Do you want to mark this invoice as paid?',
    invoice: 'Invoice',
    editInvoice: "Edit invoice",
};

const promoPageStrings = {
    emptyTable: "No promo codes found.",
    addPromo: "Add a promotion",
    promoCode: 'Code promo',
    discountAmount: "Amount",
    maxUses: "Max uses",
    usedCount: 'Used count',
    erPromoCode: 'Invalid promo code',
    erPromoCode2: 'Promo code must contain only letters and numbers',
    erMaxUses: 'Maximum number of uses is required',
    erDiscountAmount: 'Discount amount must be greater than 0',
    erUsedCount: 'Used count is required',
    validityPeriod: "Validity period",
    erValidityPeriod: "Select a start and end date",
    erMAmount: "M must be a positive integer",
    erNAmount: "N must be a positive integer",
    type: "Type",
    percentage: "Percentage",
    fixed: "Fixed",

    nAmount: "Amount (N)",
    nAmountTooltip: "Number of items given for free after purchasing M items.",

    mAmount: "Amount (M)",
    mAmountTooltip: "Number of items the customer must add to the cart to benefit from the promotion.",

    applyGroupId: "Apply to a product group",
    applyGroupIdTooltip: "If no group is selected, the promotion will apply to all product groups.",

    autoActivate: "Auto activation",
    autoActivateTooltip: "Automatically applies this promotion in the cart without requiring a promo code (including at checkout).",

    mPlusNSamePrice: "M+N same price",
    editPromo: "Edit promo",
};

const voucherPageStrings = {
    title: 'Vouchers',
    createVouchers: "Create vouchers",
    noVoucherFound: 'No voucher found.',

    code: 'Code',
    value: 'Value',
    remainingValue: 'Remaining balance',
    expiryDate: 'Expiry date',
    email: 'Email',
    productGroups: 'Allowed groups',
    status: 'Status',
    createdAt: 'Created on',
    noExpiry: 'No expiry',

    statusActive: 'Active',
    statusRevoked: 'Revoked',
    statusExpired: 'Expired',
    statusDepleted: 'Depleted',
    statusPartiallyUsed: 'Partially used',

    quantity: 'Quantity',
    quantityTooltip: 'Number of vouchers to generate in this batch (1 to 500).',
    valueTooltip: 'Amount loaded on each voucher of the batch.',
    expiryDateTooltip: 'Leave empty for a voucher that never expires.',
    emailTooltip: 'Informative only: who the voucher was given to. No email is sent.',
    productGroupsTooltip: 'Restrict the voucher to these product groups. Leave empty to allow the whole catalogue.',
    valueLockedTooltip: 'The amount can no longer be changed: this voucher has already been used.',

    createdBatchTitle: 'Vouchers created',
    createdBatchSubtitle: 'Codes have been generated. Download the printable cards now.',
    downloadPdf: 'Download PDF',
    downloadSelectionPdf: 'Download the cards of the selection',
    downloadAllPdf: 'Download all cards',
    noVoucherToDownload: 'No voucher to download',
    close: 'Close',

    activeToggle: 'Active',
    activeToggleTooltip: 'A revoked voucher stays visible but can no longer be used.',
    redemptions: 'Usage history',
    noRedemption: 'This voucher has never been used.',
    redemptionRemainingAfter: 'Balance after',
    viewAccount: 'View order',

    erQuantity: 'Quantity must be between 1 and 500',
    erValue: 'Amount must be greater than 0',
    erEmail: 'Invalid email address',
    errorPdf: 'The PDF could not be generated',
    deleteConfirm: 'This voucher will be removed from the list and can no longer be used. This action cannot be undone.'
};

const pickupPageStrings = {
    addPickup: "Add a pickup point",
    notFound: 'No Pickup found.',
    name: 'Name',
    address: "Address",
    phone: "Phone",
    openingHours: "Order Time",
    hoursField: "Times slots",
    pickupTime: "Pickup Time",
    type: "Type",
    day: "Day",
    hour: "Start",
    hour2: "End",
    add: "Add",
    erName: "Name required",
    erPhone: "Phone number required",
    erPhone2: "Invalid phone number",
    erAddress: "Address required",
    erSlot: "Please add a time slot",
    editPickup: "Edit pickup",
};

const deviceStrings = {
    emptyTable: "No devices found.",
    serialNumber: "Serial number",
    model: "Model",
    brand: "Brand",
    osVersion: "OS version",
    appVersion: "App version",
    lastUsedUser: "Last user",
    boundUser: "Bound user",
    device: "Device",
    deleteAll: "Delete all devices",
}

const deliveryAreaPageStrings = {
    title: "Delivery areas",
    newArea: "New area",
    createArea: "Create an area",
    addDeliveryArea: "Add a delivery area",
    editArea: "Edit area",
    areas: "Areas",
    noAreas: "No delivery area yet. Draw your first area on the map.",
    drawHint: "Click on the map to place the points of your area.",
    cancelDrawing: "Cancel",
    finishDrawing: "Finish area",
    undoPoint: "Remove last point",
    name: "Area name",
    namePlaceholder: "E.g. City center",
    price: "Delivery price (incl. VAT)",
    minOrderAmount: "Minimum order amount",
    freeDeliveryMinAmount: "Minimum amount for free delivery",
    defaultFromSettingsHint: "Leave at 0 to use the amount set in the organisation settings.",
    amountInvalid: "The amount must be greater than or equal to 0.",
    orderIndex: "Priority order",
    orderIndexHint: "The lower the number, the higher the priority when areas overlap.",
    orderIndexInvalid: "The priority order must be a positive whole number.",
    editShapeHint: "Move the points of the selected area directly on the map.",
    shapeModified: "Shape modified",
    saveShape: "Save shape",
    resetShape: "Discard changes",
    minPoints: "An area must contain at least 3 points.",
    nameRequired: "The area name is required.",
    priceInvalid: "The price must be greater than or equal to 0.",
    mapError: "The map could not be loaded.",
    points: "points",
    searchAddressMode: "Address",
    searchZoneMode: "Municipality",
    searchAddressPlaceholder: "Search an address",
    searchZonePlaceholder: "Postal code or municipality (e.g. 1140, 1930)",
    surroundZone: "Outline",
    removeZoneQuery: "Remove",
    zoneAlreadyAdded: "Zone already added:",
    zoneNotFound: "No boundary found for:",
    searchFailed: "The search failed.",
    zonesFound: "Boundaries found",
    discardZones: "Cancel",
    keepZones: "Create",
    createAreas: "Create the zones",
    batchHint: "One zone will be created per municipality, with the same amounts."
};

const websitePageStrings = {
    general: "General",
    image: "Images",
}

const aiDebuggerStrings = {
    title: "Posbel AI",
    investigationStarted: "Investigation started",
    requestType: "Investigation type",
    message: "Issue description",
    messageTooltip: "Required for “Other issue”. For the other types, optional detail about the incident.",
    moreOptions: "More options",
    orgId: "Organization id",
    orgIdTooltip: "Leave empty to investigate the current organization.",
    targetUser: "Affected user",
    targetUserId: "Affected user id",
    targetUserTooltip: "The register or server account the incident happened on. It must belong to the investigated organization.",
    accountId: "Account id",
    orderCode: "Order code",
    transactionId: "Transaction id",
    paymentTransactionId: "Payment transaction id",
    deviceId: "Device id",
    printerId: "Printer id",
    timeRange: "Time range",
    timeRangeTooltip: "Without a time range, the last 24 hours are analysed (7 days for “Recent menu changes”).",
    techMode: "Technical mode",
    techModeDescription: "A more technical report, meant for developers.",
    launch: "Start investigation",
    newInvestigation: "New investigation",
    investigations: "My investigations",
    noInvestigation: "No investigation",
    noInvestigationHint: "Investigations are kept for 7 days.",
    showReport: "View report",
    showError: "View error",
    hideDetails: "Hide",
    downloadReport: "Download report",
    downloadError: "The PDF could not be generated.",
    pdfTitle: "Posbel Technical Investigation",
    pdfInvestigation: "Investigation",
    pdfStatus: "Status",
    pdfRequestedBy: "Requested by",
    pdfCreatedAt: "Created on",
    pdfCompletedAt: "Completed on",
    reportEmpty: "The report is empty.",
    requestTypes: {
        PAYMENT_NOT_SENT_TO_TERMINAL: "Payment not sent to the terminal",
        KITCHEN_PRINTING_NOT_WORKING: "Kitchen printing not working",
        VAT_SUMMARY_TICKETS_NOT_PRINTING: "VAT / summary tickets not printing",
        PAYMENT_NOT_REGISTERED: "Payment not registered",
        RECENT_MENU_CHANGES: "Recent menu changes",
        OTHER: "Other issue",
    },
};

const playlistStrings = {
    loadError: "Unable to load playlists",
    disabledHint: "The digital menu is not enabled for this organisation.",
    unavailableTitle: "Digital menu unavailable",
    mediaType: "Media type",
    groupSectionLabel: "Section {index}",
    editPlaylist: "Edit playlist",
    editScene: "Edit scene",
    noScene: "No scene in this playlist",
    sceneCount: "{count} scene | {count} scenes",
    columnLabel: "Column {index}",
    columnHeader: "Column header",
    columnSectionCount: "{count} section | {count} sections",
    columnEmpty: "Add a section to fill this column.",
    typeImage: "Image",
    typeVideo: "Video",
    typeMenu: "Menu",
    name: "Name",
    transitionDuration: "Transition duration (sec)",
    transitionType: "Transition type",
    fade: "Fade",
    slide: "Slide",
    addPlaylist: "Add playlist",
    addScene: "Add scene",
    playlist: "Playlist",
    productGroups: "Product groups",
    orderIndex: "Order",
    duration: "Display duration",
    contentType: "Content type",
    templateName: "Theme",
    backgroundType: "Background type",
    background: "Background URL",
    vertical: "Vertical TV",
    template4Config: {
        chipsHeader: "Header",
        chipsTheme: "Theme",
        chipsLayout: "Layout",
        chipsColumns: "Columns",
        chipsTypography: "Typography",
        chipsStyle: "Style",
        subtitleStructure: "Structure",
        subtitleSpacing: "Spacing",
        subtitleOffsets: "Offsets",
        subtitleAlignment: "Alignment",
        subtitleCardPreset: "Card Preset",
        subtitleVisibility: "Visibility",
        subtitleMainHeader: "Main Header",
        subtitleColumnHeader: "Column Header",
        subtitleMenuContent: "Menu Content",
        subtitleColorSection: "Color",
        title: "Title",
        titleTooltip: "Main header shown above the menu.",
        subtitle: "Subtitle",
        subtitleTooltip: "Secondary line shown under the main header.",
        headerColumns: "Header columns",
        headerColumnsTooltip: "Choose if the main header uses only the first column or spans the first two.",
        firstColumnOnly: "First column only",
        firstTwoColumns: "First two columns",
        headerBottomSpacing: "Header bottom spacing",
        headerBottomSpacingTooltip: "Vertical space between the main header and the start of column content.",
        headerAlign: "Header align",
        headerAlignTooltip: "Horizontal alignment of the main header text.",
        titleSize: "Title size",
        titleSizeTooltip: "Font size used for the main header title.",
        subtitleSize: "Subtitle size",
        subtitleSizeTooltip: "Font size used for the main header subtitle.",
        titleColor: "Title color",
        titleColorTooltip: "Text color of the main header title.",
        subtitleColor: "Subtitle color",
        subtitleColorTooltip: "Text color of the main header subtitle.",
        columnTitleColor: "Column title color",
        columnTitleColorTooltip: "Text color for per-column titles.",
        columnSubtitleColor: "Column subtitle color",
        columnSubtitleColorTooltip: "Text color for per-column subtitles.",
        backgroundColor: "Background color",
        backgroundColorTooltip: "Background color of the full template.",
        textColor: "Text color",
        textColorTooltip: "Default text color used in menu content.",
        groupBackground: "Group Background",
        groupBackgroundTooltip: "Base color used to render group card backgrounds.",
        accentColor: "Accent color",
        accentColorTooltip: "Accent color used for highlights, titles and prices.",
        language: "Language",
        languageTooltip: "Language used when choosing translated product descriptions.",
        contentPadding: "Content Padding",
        contentPaddingTooltip: "Inner padding around all menu content.",
        showPrices: "Show prices",
        showPricesTooltip: "Show or hide product prices.",
        showEuroSymbol: "Show € symbol",
        showEuroSymbolTooltip: "Display or hide the euro symbol next to prices.",
        showDots: "Show dots",
        showDotsTooltip: "Show dotted leader between product name and price.",
        showDescriptions: "Show descriptions",
        showDescriptionsTooltip: "Show or hide product descriptions under product names.",
        showProductImage: "Show product image",
        showProductImageTooltip: "Display a square product image on each product row when available.",
        productImageSize: "Product image size",
        productImageSizeTooltip: "Square size in pixels used for product images (width and height).",
        productCardStyle: "Product card style",
        productCardStyleTooltip: "Visual preset used for group and product card rendering.",
        columns: "Columns",
        columnsTooltip: "Total number of columns displayed in the template.",
        columnGap: "Column gap",
        columnGapTooltip: "Horizontal space between columns.",
        groupSpacing: "Group spacing",
        groupSpacingTooltip: "Vertical space between groups inside one column.",
        leftEmptySpace: "Left empty space",
        leftEmptySpaceTooltip: "Reserved empty space on the left side before columns start.",
        rightEmptySpace: "Right empty space",
        rightEmptySpaceTooltip: "Reserved empty space on the right side after columns end.",
        columnHeaderSpacing: "Column header spacing",
        columnHeaderSpacingTooltip: "Space between per-column header and the first group of that column.",
        columnHeaderAlign: "Column header align",
        columnHeaderAlignTooltip: "Horizontal alignment of per-column title and subtitle.",
        left: "Left",
        center: "Center",
        right: "Right",
        classic: "Classic",
        modern: "Modern",
        minimal: "Minimal",
        compact: "Compact",
        clean: "Clean",
        framed: "Framed",
        addColumn: "Add Column",
        columnHeaderSection: "Column header",
        showColumnHeader: "Show header",
        showColumnHeaderTooltip: "Enable or disable title/subtitle block for this specific column.",
        columnTitle: "Column title",
        columnTitleTooltip: "Title displayed above this column.",
        columnSubtitle: "Column subtitle",
        columnSubtitleTooltip: "Subtitle displayed below the column title.",
        groupSection: "Group section",
        productGroup: "Product group",
        productGroupTooltip: "Select which product group is rendered in this section.",
        selectProductGroup: "Select a product group",
        visibleProducts: "Visible products",
        visibleProductsTooltip: "Choose which products of the selected group are shown in this section.",
        selectVisibleProducts: "Select visible products",
        addGroupSection: "Add group section",
        columnTitleSize: "Column Title Size",
        columnTitleSizeTooltip: "Font size of per-column titles.",
        columnSubtitleSize: "Column Subtitle Size",
        columnSubtitleSizeTooltip: "Font size of per-column subtitles.",
        groupSize: "Group Size",
        groupSizeTooltip: "Font size of group titles.",
        productSize: "Product Size",
        productSizeTooltip: "Font size of product names.",
        descriptionSize: "Description Size",
        descriptionSizeTooltip: "Font size of product descriptions."
    }
}

const topBarStrings = {
    searchPlaceholder: "Search, navigate, act...",
    interfaceSettings: "Interface settings",
    openMenu: "Open menu",
    account: "My account",
    testEnvironment: "Test environment"
};

const preferencesPageStrings = {
    showTableIds: "Show identifiers",
    showTableIdsTooltip: "Shows a column with the technical identifier in tables. Visible to super users only.",
    name: "Interface",
    description: "These settings are specific to this browser and are stored locally.",
    language: "Interface language",
    languageTooltip: "Language of the admin, independent from the browser one.",
    languageAuto: "Automatic",
    languageNl: "Nederlands",
    languageFr: "Français",
    languageEn: "English",
    favorites: "Favorites",
    favoriteLinks: "Favorite links",
    favoriteLinksTooltip: "The selected pages appear in a Favorites section at the top of the side menu.",
    sideNavAlwaysExpanded: "Keep the side menu open",
    sideNavAlwaysExpandedTooltip: "The side menu stays expanded instead of collapsing automatically."
};

const createOrgPageStrings = {
    validation: {
        name: "The organisation name is required",
        contactEmail: "A valid email address is required",
        orgType: "The organisation type is required",
        blackboxFdm: "The FDM ID is required",
        establishmentNumber: "The establishment number is required"
    }
};

const importPageStrings = {
    steps: {
        file: {
            label: "File",
            title: "Choose the file to import",
            description: "An Excel workbook exported from Posbel or filled from the template, or a CSV file.",
        },
        columns: {
            label: "Columns",
            title: "Column mapping",
            description: "Match each column of your file to a Posbel field. Ignored columns are not imported.",
        },
        check: {
            label: "Check",
            title: "File check",
            description: "Every line has been checked. Lines with errors will be left out, invalid values ignored.",
        },
        references: {
            label: "References",
            title: "Unknown references",
            description: "Match the names that point to nothing.",
        },
        groups: {
            label: "Groups",
            title: "Groups",
            description: "Review the groups to create and the ones that will be reused.",
        },
        optionLists: {
            label: "Option lists",
            title: "Option lists",
            description: "Review the lists and their choices.",
        },
        summary: {
            label: "Summary",
            title: "Summary",
            description: "Choose the products to import.",
        },
    },
    dropTitle: "Drop your file here",
    dropSubtitle: "or click to choose it",
    readingFile: "Reading {file}...",
    templateHint: "No file yet? Start from the template: it has every column, help under each header and examples.",
    changeFile: "Change file",
    readyTitle: "The file can be imported",
    blockedTitle: "The file cannot be imported as it is",
    blockedDescription: "Fix the general errors below in your file, then upload it again.",
    countProducts: "{count} product | {count} products",
    countGroups: "{count} group | {count} groups",
    countOptionLists: "{count} option list | {count} option lists",
    sheetOf: "out of {count} line | out of {count} lines",
    sheetExcluded: "{count} left out | {count} left out",
    sheetWarned: "{count} warning | {count} warnings",
    sheetAllValid: "All valid",
    issuesTitle: "Issues found",
    filterAll: "All",
    filterErrors: "Errors",
    filterWarnings: "Warnings",
    filterFixed: "Fixed",
    issueRow: "line {row}",
    express: {
        button: "Express import",
        title: "Express import",
        intro: "The default choice of every step is applied and the import is sent right away.",
        notice: "Good to know",
        lines: {
            products: "Product to import | Products to import",
            groupsCreated: "Group to create | Groups to create",
            groupsReused: "Existing group reused | Existing groups reused",
            optionLists: "Option list | Option lists",
            excluded: "row excluded | rows excluded",
            existing: "product already in Posbel skipped | products already in Posbel skipped",
            matched: "name matched automatically | names matched automatically",
            renamed: "product name fixed | product names fixed",
        },
        blockers: {
            columns: "Map the required columns first: name, group and price.",
            blocked: "The file has a blocking error, fix it in the Check step.",
            groupVat: "Some new groups have no VAT, set it in the Groups step.",
            noProducts: "No product to import.",
        },
    },
    fix: {
        clear: "Clear",
        skip: "Skip row",
        newValue: "New value",
        apply: "Apply",
        edited: "Value replaced with “{value}”.",
        cleared: "Cell cleared.",
        skipped: "Row skipped, it will not be imported.",
        skipRows: "Skip rows",
        editTitle: "Edit value",
        editManyTitle: "Edit {count} cell | Edit {count} cells",
        currentValue: "current value “{value}”",
        columns: "Columns: {columns}",
        mixedColumns: "The cells come from several columns: the same value will be applied to all of them.",
        applySuggestion: "Apply suggestion",
        applySuggestions: "Apply suggestions",
    },
    columns: {
        sheet: "Sheet",
        required: "Required:",
        ignore: "Ignore",
        untitled: "Column {number}",
        fields: {
            name: "Name",
            group: "Group",
            priceVatInclIn: "Dine-in price",
            priceVatInclOut: "Takeaway price",
            vatIn: "Dine-in VAT",
            vatOut: "Takeaway VAT",
            barcodes: "Barcodes",
            descriptionFr: "Description (FR)",
            descriptionNl: "Description (NL)",
            descriptionEn: "Description (EN)",
            color: "Color",
            imageUrl: "Image",
            externalReference: "Reference",
            purchasePriceVatExcl: "Purchase price excl. VAT",
            orderIndex: "Order",
            userHidden: "Hidden on POS",
            webHidden: "Hidden on web",
            kioskHidden: "Hidden on kiosk",
            dynamicPrice: "Dynamic price",
            weightPrice: "Price by weight",
        },
    },
    optionLists: {
        offeredOn: "offered on {count} product | offered on {count} products",
        choiceCount: "{count} choice | {count} choices",
        without: "Without {name}",
        maxTimes: "{count} times max",
        multiple: "Several times",
        free: "Free",
        pricePerChannel: "Price per channel",
        noChoice: "No choice in this list.",
    },
    summary: {
        selectedProducts: "{count} product out of {total} to import | {count} products out of {total} to import",
        optionLists: "{count} option list | {count} option lists",
        existing: "{count} product already exists with this name in this group: it is unticked to avoid a duplicate. | {count} products already exist with this name in their group: they are unticked to avoid duplicates.",
        existingTag: "Already in Posbel",
        submit: "Import {count} product | Import {count} products",
        success: "Import completed",
    },
    groups: {
        setVat: "Set the VAT",
        toCreate: "{count} group to create | {count} groups to create",
        toReuse: "{count} existing group reused | {count} existing groups reused",
        missingVat: "Set the eat-in and takeaway VAT of every new group to continue.",
        new: "New",
        existing: "Already in Posbel",
        unchanged: "Existing group, it will not be changed",
        productCount: "{count} product | {count} products",
    },
    references: {
        autoCorrected: "{count} name recognised despite a difference in case, accents or spaces. | {count} names recognised despite a difference in case, accents or spaces.",
        kinds: {
            group: "Groups",
            optionList: "Option lists",
            product: "Choice products",
        },
        create: {
            group: "Create a new group \"{value}\"",
            optionList: "Create a new list \"{value}\"",
        },
        replaceWith: "Replace with \"{value}\"",
        ignore: "Ignore this choice",
        fromFile: "In the file",
        fromPosbel: "Already in Posbel",
        ambiguous: "Several products have this name",
        rows: "line {rows} | lines {rows}",
        allMatch: "Every name in the file has been found",
    },
    issues: {
        unsupportedFormat: "Unsupported format. Use an .xlsx or .csv file.",
        readError: "The file could not be read. Check that it is not damaged or password protected.",
        missingSheet: "The {sheet} sheet cannot be found in the file.",
        noProducts: "No valid product to import.",
        unknownSheet: "Unknown sheet {sheet}, it is ignored.",
        optionListsDisabled: "Option lists are not enabled, the {sheet} sheet is ignored.",
        unknownColumns: "Unknown columns, ignored: {columns}.",
        missingColumn: "Required column {column} not found. The whole sheet is ignored.",
        required: "Required value missing. Line left out.",
        invalidNumber: "\"{value}\" is not a number. Line left out.",
        invalidInteger: "\"{value}\" is not a whole number. Line left out.",
        negative: "\"{value}\" cannot be negative. Line left out.",
        invalidVat: "\"{value}\" is not a valid VAT rate ({rates}). Line left out.",
        invalidBoolean: "\"{value}\" is not yes or no. Value ignored.",
        invalidColor: "\"{value}\" is not a hexadecimal colour. Value ignored.",
        invalidBarcode: "\"{value}\" is not a valid barcode, it must contain digits only. Value ignored.",
        barcodeTooLong: "Barcode “{value}” is too long to be saved. Value ignored.",
        duplicate: "\"{value}\" already appears on line {row}. Line left out.",
        invalidName: "“{value}” contains characters that are not allowed. Suggestion: “{suggestion}”. Row excluded.",
        invalidNameNoSuggestion: "“{value}” contains no allowed character (letters, digits, spaces and - . , ' \" ( ) & % ° / +). Row excluded.",
        tooLong: "“{value}” is {length} characters long, the maximum is {max}. Row excluded.",
        duplicateBarcode: "Barcode {value} is already used on line {row}. Row excluded.",
    },
};

const catalogWorkbookStrings = {
    required: "Required",
    optional: "Optional",
    validation: {
        title: "Invalid value",
        reference: "Pick a value from the list, which comes from the {sheet} sheet. For a new value, first add it to the {sheet} sheet.",
        boolean: "Pick {yes} or {no}.",
        vat: "Pick a VAT rate: {rates}.",
    },
    help: {
        products: {
            name: "Product name.",
            group: "Product group, with the full path for a subgroup: {example}. Pick a group from the Groups sheet or type a new one: it will be created during the import.",
            priceVatInclIn: "Eat-in price including VAT.",
            priceVatInclOut: "Takeaway price including VAT. Empty = same price as eat-in.",
            vatIn: "Eat-in VAT rate as a percentage: 0, 6, 12 or 21. Empty = the group VAT.",
            vatOut: "Takeaway VAT rate as a percentage. Empty = same rate as eat-in.",
            barcodes: "Barcodes, several separated by a comma.",
            descriptionFr: "Description in French.",
            descriptionNl: "Description in Dutch.",
            descriptionEn: "Description in English.",
            color: "Button colour in hexadecimal: {example}.",
            imageUrl: "https link to the product image.",
            externalReference: "Your own reference (item code, SKU...).",
            purchasePriceVatExcl: "Purchase price excluding VAT.",
            orderIndex: "Display position in the group, whole number.",
            userHidden: "Hide the product on the till. Empty = no.",
            webHidden: "Hide the product on online ordering. Empty = no.",
            kioskHidden: "Hide the product on the kiosk. Empty = no.",
            dynamicPrice: "Dynamic price: the price is entered on the till when the product is selected, the price on this row is ignored. Empty = no.",
            weightPrice: "Price by weight: the price on this row is a price per kilo and the weight is asked when the product is selected. Empty = no.",
            optionLists: "Option lists offered when this product is ordered, by name (name column of the OptionLists sheet), several separated by a comma, in display order.",
            freeOptionGroups: "Legacy options: groups whose products are offered for free, several separated by a comma.",
            paidOptionGroups: "Legacy options: groups whose products are offered at a price, several separated by a comma.",
            productId: "Posbel product id. Filled on export, ignored on import.",
            stock: "Current stock. Filled on export, ignored on import.",
        },
        groups: {
            path: "Full path of the group: {example}. A parent group needs its own line.",
            vatIn: "Default eat-in VAT of the group's products, as a percentage.",
            vatOut: "Default takeaway VAT of the group's products, as a percentage.",
            color: "Group colour in hexadecimal: {example}.",
            orderIndex: "Display position of the group, whole number.",
            userHidden: "Hide the group on the till. Empty = no.",
            webHidden: "Hide the group on online ordering. Empty = no.",
            kioskHidden: "Hide the group on the kiosk. Empty = no.",
            imageUrl: "https link to the group image.",
            externalReference: "Your own reference.",
            maxChoiceFree: "Legacy options: maximum number of free choices in this group.",
            maxChoicePaid: "Legacy options: maximum number of paid choices in this group.",
            forceChoiceAmountFree: "Legacy options: required number of free choices.",
            forceChoiceAmountPaid: "Legacy options: required number of paid choices.",
        },
        optionLists: {
            name: "List name. This is the name written in the optionLists column of the products and in the list column of the choices.",
            nameFr: "Name shown in French. Empty = the name column.",
            nameNl: "Name shown in Dutch. Empty = the name column.",
            nameEn: "Name shown in English. Empty = the name column.",
            descriptionFr: "Description in French.",
            descriptionNl: "Description in Dutch.",
            descriptionEn: "Description in English.",
            minChoice: "Minimum number of choices. Empty = no minimum.",
            maxChoice: "Maximum number of choices. Empty = no maximum.",
            forceChoice: "Exact number of choices required. Empty = not required.",
        },
        optionListItems: {
            list: "List name (name column of the OptionLists sheet). The order of the lines is the order of the choices in the list.",
            product: "Name of the product offered as a choice (Products sheet).",
            productGroup: "Group of the product. Only needed when two products share the same name.",
            free: "Free choice. Empty = no.",
            without: "\"Without ...\" choice: the customer removes this product. Empty = no.",
            allowMultipleChoice: "The customer can take this choice several times. Empty = no.",
            maxChoice: "Maximum number of times for this choice. Empty = no limit.",
            includeOptionLists: "When this choice is taken, also offer the option lists of the product. Empty = no.",
            priceIn: "Special eat-in price for every channel. Empty = product price.",
            priceOut: "Special takeaway price for every channel. Empty = product price.",
            priceAppIn: "Special eat-in price on the till. Replaces priceIn for this channel.",
            priceAppOut: "Special takeaway price on the till. Replaces priceOut for this channel.",
            priceWebIn: "Special eat-in price on online ordering. Replaces priceIn for this channel.",
            priceWebOut: "Special takeaway price on online ordering. Replaces priceOut for this channel.",
            priceKioskIn: "Special eat-in price on the kiosk. Replaces priceIn for this channel.",
            priceKioskOut: "Special takeaway price on the kiosk. Replaces priceOut for this channel.",
        },
    },
    examples: {
        dishes: "Dishes",
        pizzas: "Pizzas",
        extras: "Extras",
        drinks: "Drinks",
        pizzaName: "Margherita",
        pizzaDescription: "Tomato, mozzarella, basil",
        toppingName: "Extra mozzarella",
        drinkName: "Still water 50 cl",
        listName: "Pizza extras",
        listDescription: "Choose up to 3 extras",
    },
};

const quickMenuStrings = {
    argumentTextPlaceholder: "Your search...",
    argumentIdPlaceholder: "Id...",
    askProduct: "Start typing a product name or id",
    askGroup: "Start typing a group name or id",
    askClient: "Start typing a client name or id",
    askStock: "Start typing a product name or id",
    askOrg: "Start typing an organisation name or id",
    askAccount: "Enter an account id",
    askShift: "Enter a shift id",
    askShiftStat: "Enter a shift id",
    commandProduct: "Go to a product",
    commandGroup: "Catalog — Go to a group",
    commandClient: "Go to a client",
    commandStock: "Product stock",
    commandOrg: "Switch organisation",
    commandAccount: "Open an account",
    commandShift: "Open a shift",
    commandShiftStat: "Shift statistics",
    kindCommand: "Command",
    argumentPlaceholder: "Name or id...",
    hintComplete: "complete",
    switchOrg: "Switch to",
    jump: "Open directly",
    kindJump: "Shortcut",
    openAccount: "Open account",
    openShift: "Open shift",
    openShiftStat: "Shift statistics",
    openProduct: "Open product",
    openGroup: "Open group",
    openClient: "Open client",
    openStock: "Product stock",
    clearRecent: "Clear",
    settingsFields: "Settings",
    hintTabSettings: "Tab to edit",
    hintSave: "save",
    openInSettings: "Open in settings",
    results: "Results",
    suggestions: "Suggestions",
    placeholder: "Search a page or an action...",
    goTo: "Go to",
    actions: "Quick actions",
    recent: "Recent",
    kindPage: "Page",
    kindAction: "Action",
    hintMove: "navigate",
    hintOpen: "open",
    hintToggle: "quick menu"
}

export default {
    quickMenu: quickMenuStrings,
    generic: genericStrings,
    navBar: navBarStrings,
    toast: toastStrings,
    playlist: playlistStrings,
    deviceStrings: deviceStrings,
    dashboard: dashboardStrings,
    productGroupsDashboard: productGroupsDashboardStrings,
    loginPage: loginPageStrings,
    userPage: userPageStrings,
    superUserPage: superUserPageStrings,
    productGroupPage: productGroupPageStrings,
    productPage: productPageStrings,
    productOptionsPage: productOptionsPageStrings,
    catalogPage: catalogPageStrings,
    catalogWorkbook: catalogWorkbookStrings,
    importPage: importPageStrings,
    stockPage: stockPageStrings,
    tablePage: tableStrings,
    pickupPageStrings: pickupPageStrings,
    paymentsPage: paymentsStrings,
    orderedProductsPage: orderedProductsString,
    accountHistoryPage: accountHistory,
    openAccountsPage: openAccounts,
    shiftDetailPage: shiftDetail,
    shiftStatPage: shiftStat,
    clientStrings: clientStrings,
    shiftPage: shift,
    integrationStrings: integrationStrings,
    printerStrings: printerStrings,
    aiDebugger: aiDebuggerStrings,
    settingsPage: settingsPageStrings,
    deliveryAreaPage: deliveryAreaPageStrings,
    invoicePage: invoicePageStrings,
    kitchenPageStrings: kitchenPageStrings,
    promoPageStrings: promoPageStrings,
    voucherPageStrings: voucherPageStrings,
    imagePageStrings: imagePageStrings,
    iconsPageStrings: iconsPageStrings,
    websitePageStrings: websitePageStrings,
    topBar: topBarStrings,
    preferencesPage: preferencesPageStrings,
    createOrgPage: createOrgPageStrings
};
